import { useEffect } from "react";
import { HexColorPicker } from "react-colorful";
import { getIn } from "formik";

const ColorPickerField =({ label, name, formik })=> {
    const colorValue = getIn(formik.values, name) || "#ff0000"; // fallback color

     useEffect(() => {
    // ✅ Ensure Formik has the default value on mount
    const currentValue = getIn(formik.values, name);
    if (!currentValue) {
      formik.setFieldValue(name, "#ff0000");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);

   const handleInputChange = (e) => {
    const value = e.target.value;

    // Allow only up to 7 characters (# + 6 hex digits)
    if (value.length <= 7) {
      // Allow empty, '#' or valid hex-like inputs
      if (/^#?[0-9A-Fa-f]*$/.test(value)) {
        formik.setFieldValue(name, value);
      }
    }
  };
  
    return (
    <div className="input-wrap pro-mb-4">
      <label htmlFor={name} className="pro-label">{label}</label>

      <HexColorPicker
        color={/^#([0-9A-Fa-f]{3}){1,2}$/.test(colorValue) ? colorValue : "#ffffff"}
        onChange={(color) => formik.setFieldValue(name, color)}
        style={{ width: "100%", height: "150px", borderRadius: "8px" }}
      />

      <input
        type="text"
        id={name}
        name={name}
        value={colorValue}
        onChange={handleInputChange}
        maxLength={7} // optional — prevents extra input at UI level too
        className={`pro-input lg ${getIn(formik.errors, name) ? "error" : ""}`}
      />

      {/* {formik.errors[name] && (
        <div className="error-text">{formik.errors[name]}</div>
      )} */}
    </div>
  );
}
export default ColorPickerField;